import type { ZapiPath } from '@weft/zapi-types';
import { PATH_ACCESS_LEVELS } from '@weft/zapi-types';
import { NEST_API_TAGS } from '../../api-tags';

export const GET_CREDIT_LEDGER_OVERVIEW_PATH = {
  accessLevel: PATH_ACCESS_LEVELS.PRIVATE,
  route: '/credit-ledger/overview',
  tags: NEST_API_TAGS.CREDIT_LEDGER,
} satisfies ZapiPath;

export type GetCreditLedgerOverviewPath = typeof GET_CREDIT_LEDGER_OVERVIEW_PATH;